module.exports = __webpack_public_path__ + "static/img/nav-arrow.6fc46b79.svg";